<template>
  <h4 class="font-weight-medium mb-2">
    {{ $t('L_contact_message') }}
  </h4>
  <v-textarea
    :id="idProp"
    :class="{ 'message-has-value': hasTypedCharacters }"
    v-model="formInput.$model"
    :autocomplete="disableAutocomplete ? 'off' : undefined"
    :color="color"
    :error-messages="errorMessages"
    @update:model-value="onInput"
    @blur="onBlur"
    :aria-describedby="describers"
    :placeholder="$t('L_type_your_message_here')"
    maxlength="500"
    rows="7"
  >
    <template #append-inner>
      <v-icon :icon="mdiCheckCircle" :color="messageIconColor" />
    </template>
  </v-textarea>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { mdiCheckCircle } from '@mdi/js';
import BaseTextField from '../BaseTextField.vue';

const componentOptions: ComponentOptions = {
  name: 'MessageInput',
  extends: BaseTextField,
  computed: {
    hasTypedCharacters() {
      return String(this.formInput?.$model ?? '').length > 0;
    },
    messageIconColor() {
      return this.hasTypedCharacters ? 'success' : '#000000';
    },
  },
  props: {
    idProp: {
      type: String,
      required: false,
      default: 'message',
    },
  },
  data: () => ({
    modelName: 'message',
    message: '',
    mdiCheckCircle,
  }),
};

export default defineComponent(componentOptions);
</script>
